export const metaHeadlineSlots = {
  cover: {force: true},
  title: {},
  link: {},
}
